export default {
    returnToWig: 'חזור לפאה',
    optionalID: 'ת.ז. (רשות)',
    includeVAT: 'כולל מע"מ',
    selectPaymentType: 'בחר שיטת תשלום',
    enterAmount: 'הזן סכום',
    enterFirstAmount: 'סכום לתשלום ראשון',
    totalAmount: 'סכום כולל',
    commentForPaymentType: 'הערות',
    selectBankCode: "מס' בנק",
    enterCheckNumber: 'מספר שיק',
    enterBranchNumber: 'סניף',
    enterBankAccountNumber: '4 ספרות כ.א.',
    enterERNReferenceNumber: 'מספר אסמכתא ERN',
    enterFullBankAccountNumber: 'מספר חשבון בנק',
    quantityOfPayments: "מס' תשלומים",
    addPayment: 'הוסף תשלום',
    save: 'שמור תשלום',
    addAnotherCheck: 'הוסף שיק נוסף',
    confirmWithoutOptionalID: 'לא הוזנה ת.ז. להמשיך בכל זאת?',
    saveWithRivhitPaymentSystem: 'האם לשדר לריווחית?',
    saveWithRivhit: 'שמירה ושידור לריווחית',
    saveOnlyLocally: 'שמירה בלבד',
    enterDescription: 'תיאור',
    paymentProcessing: 'שם הלקוחה',
    fieldIsRequired: 'חובה להזין',
    dueDate: 'תאריך פרעון',
    firstName: 'שם פרטי',
    lastName: 'שם משפחה',
    clientsName: 'שם הלקוחה',
    taxInvoiceAndReceipt: 'הפקת חשבונית מס קבלה',
    confirm: 'אישור',
    checkFields: 'נא לוודא שכל השדות מולאו',
    paymentType: 'שיטת תשלום',
    paymentSavedLocally: 'התשלום נשמר במערכת בהצלחה!',
    paymentSavedWithRivhit: 'התשלום דווח לריווחית בהצלחה!',
    errorSavingPayment: 'משהו השתבש בתהליך הדיווח לריווחית',
    receiptOnly: 'קבלה בלבד',
    optionalIdDigits: 'חובה להזין 9 ספרות',
    ['שיק']: 'שיק',
    ['מזומן']: 'מזומן',
    ['ישראכרט']: 'ישראכרט',
    ['ויזה']: 'ויזה',
    ['כ. אשראי אחר']: 'כ. אשראי אחר',
    ['דיינרס']: 'דיינרס',
    ['אמקס']: 'אמקס',
    ['העברה בנקאית']: 'העברה בנקאית',
    ['הוראת קבע בנקאית']: 'הוראת קבע בנקאית',
    ['מאסטרכארד']: 'מאסטרכארד',
    ['בנק שלי']: 'בנק שלי',
    ['יורו טרייד']: 'יורו טרייד',
    ['צפון אמריקאי']: 'צפון אמריקאי',
    ['יהב']: 'יהב',
    ['בנק מזרחי טפחות']: 'בנק מזרחי טפחות',
    ['לפתוח התעשריה']: 'לפתוח התעשריה',
    ['הספנות']: 'הספנות',
    ['הדואר']: 'הדואר',
    ['לאומי']: 'לאומי',
    ['דיסקונט']: 'דיסקונט',
    ['הפועלים']: 'הפועלים',
    ['איגוד']: 'איגוד',
    ['אוצר החייל']: 'אוצר החייל',
    ['מרכנתיל דיסקונט']: 'מרכנתיל דיסקונט',
    ['One Zero']: 'One Zero',
    ['החקלאות לישראל']: 'החקלאות לישראל',
    ['מזרחי טפחות']: 'מזרחי טפחות',
    ['אמריקאי ישראלי']: 'אמריקאי ישראלי',
    ['כללי']: 'כללי',
    ['קונטיננטל ישראל']: 'קונטיננטל ישראל',
    ['הבינלאומי הראשון']: 'הבינלאומי הראשון',
    ['מימון וסחר']: 'מימון וסחר',
    ['ערבי ישראלי']: 'ערבי ישראלי',
    ['בנק פאגאקו']: 'בנק פאגאקו',
    ['מסד']: 'מסד',
    ['בנק עולמי']: 'בנק עולמי',
    ['פאג"י']: 'פאג"י',
    ['עליה']: 'עליה',
    ['ירושלים']: 'ירושלים',
    ['בנק ישראל']: 'בנק ישראל',
    enterCheckAmount: 'סכום השיק',
    multiplePayments: 'מרובים',
    bankDirectDebit: 'הוראת קבע בנקאית',
}
